type EntitlementLike = {
  productType?: string;
  trackVersionId?: string | null;
  productId?: string | null;
};

export function indexTrackVersionEntitlements<T extends EntitlementLike>(entitlements: T[]) {
  const byVersionId = new Map<string, T>();

  for (const entitlement of entitlements) {
    if (entitlement.productType !== 'TRACK_VERSION') continue;
    const versionId = entitlement.trackVersionId || entitlement.productId;
    if (versionId) byVersionId.set(versionId, entitlement);
  }

  return byVersionId;
}

export function shouldRefreshCratesEntitlements(
  userId: string | null | undefined,
  detail: { refreshLibrary?: boolean }
) {
  return Boolean(userId && detail.refreshLibrary);
}
